export default {
  path: '/manufactors',
  component: () =>
    import(
      '@/components/pages/Manufactors/Manufactors.vue'
    )
}
